import { DEFAULT_ICON_PREFIX, FILLED_PREFIX } from './icon.constants';
export var isFilledIconExists = function (name, context) {
    return context.ownerDocument.querySelector("#" + DEFAULT_ICON_PREFIX + "-" + FILLED_PREFIX + "-" + name)
        ? true
        : false;
};
